module.exports = __webpack_public_path__ + "static/img/05.ad7c109.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/11/05.jpg
// module id = tiLc
// module chunks = 2